module.exports = __webpack_public_path__ + "img/UK_Logo_Transparent_Bak_Svart_653px.de4e0bb4.png";